type ResponseRow = { responseId: number; listing: { id: number }; status: string };

const ACTIVE_STATUSES = ['MESSAGED', 'APPLIED', 'NEGOTIATING', 'PENDING_ACCEPTANCE'];

/**
 * Whether a row freshly read after an action still belongs in the list for this
 * filter. [MCV-1850] Declined (REJECTED) and withdrawn rows leave the default
 * `all` view, and come back only while "Show declined & withdrawn" is checked.
 */
export const isReceivedResponseVisible = (
  refreshed: { status: string } | null,
  filter: 'all' | 'active' | 'accepted',
  includeDeclined: boolean
): boolean => {
  if (!refreshed) return false;
  if (filter === 'accepted') return refreshed.status === 'ACCEPTED';
  if (filter === 'active') return ACTIVE_STATUSES.includes(refreshed.status);
  return includeDeclined || (refreshed.status !== 'REJECTED' && refreshed.status !== 'WITHDRAWN');
};

/** Fold a newer operation read into a list without importing another listing's rows. */
export const reconcileReceivedResponseRows = <T extends ResponseRow>(
  rows: T[],
  original: { responseId: number; listingId: number },
  refreshed: T | null,
  filter: 'all' | 'active' | 'accepted',
  includeDeclined: boolean
): T[] =>
  rows.flatMap((row) => {
    if (row.responseId !== original.responseId || row.listing.id !== original.listingId)
      return [row];
    return refreshed && isReceivedResponseVisible(refreshed, filter, includeDeclined)
      ? [refreshed]
      : [];
  });
